// Pure decision logic for Utilities tab load telemetry. Kept free of React and
// store imports so it can be unit tested directly.

export const POLL_INTERVAL_MS = 2_000;
// Give up after 5 minutes. Derive the attempt cap from the interval so the two
// can't drift apart when the interval is retuned.
export const POLL_TIMEOUT_MS = 5 * 60_000;
export const MAX_POLL_ATTEMPTS = POLL_TIMEOUT_MS / POLL_INTERVAL_MS;
// Soft threshold: fire a "slow load" signal but keep polling. Chosen above 30s
// because loads longer than 30s are common enough to be noise.
export const SLOW_LOAD_THRESHOLD_MS = 60_000;

export type UtilitiesLoadOutcome = 'completed' | 'failed' | 'timed_out';
export type PollResolution = UtilitiesLoadOutcome | 'pending';

/** Maps the polled projectAgenciesTaskStatus + attempt count to what the tab should do next. */
export function resolvePollOutcome(status: string | undefined, attempts: number): PollResolution {
  if (status === 'completed') return 'completed';
  if (status === 'failed') return 'failed';
  if (attempts >= MAX_POLL_ATTEMPTS) return 'timed_out';
  return 'pending';
}

/** True exactly once: the first poll tick at or past the slow-load threshold. */
export function shouldFireSlowLoadSignal(elapsedMs: number, alreadyFired: boolean): boolean {
  return !alreadyFired && elapsedMs >= SLOW_LOAD_THRESHOLD_MS;
}
